import { gql } from '~src/generated/portal/gql';

export const projectSubscription = gql(`
  subscription ProjectSubscription($partnerId: String!) {
    projectUpdated {
      project(partnerId: $partnerId) {
        __typename
        id
        projectStatus
        submissionStatus

        rcVersion {
          __typename
          version
          dateAdded
        }

        progress {
          testsPassed
          totalTests
        }

        adkVersion {
          __typename
          major
          minor
          patch
        }

        appVersion {
          major
          minor
          patch
        }
        rcVersion {
          __typename
          version
          dateAdded
        }
      }
    }
  }
`);
